(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-testimonials]').forEach((section) => {
      const scroller = section.querySelector('[data-testimonials-scroller]');
      const pager = section.querySelector('[data-testimonials-pager]');
      let dots = [];
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      const renderPager = () => {
        if (!pager) return;
        const pageCount = Math.max(1, Math.ceil(scroller.scrollWidth / scroller.clientWidth));
        pager.replaceChildren(
          ...Array.from({ length: pageCount }, (_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = `product-testimonials__dot${index === 0 ? ' is-active' : ''}`;
            dot.dataset.testimonialPage = index;
            dot.setAttribute('aria-label', `Show testimonial page ${index + 1}`);
            dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
            return dot;
          })
        );
        pager.hidden = pageCount < 2;
        dots = [...pager.querySelectorAll('[data-testimonial-page]')];
        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            scroller.scrollTo({
              left: Number(dot.dataset.testimonialPage) * scroller.clientWidth,
              behavior: 'smooth',
            });
          });
        });
      };

      const updatePager = () => {
        if (!dots.length) return;
        const pageIndex = Math.min(
          dots.length - 1,
          Math.round(scroller.scrollLeft / scroller.clientWidth)
        );

        dots.forEach((dot, index) => {
          const active = index === pageIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      renderPager();
      scroller.addEventListener('scroll', updatePager, { passive: true });
      window.addEventListener('resize', renderPager);

      scroller.addEventListener('pointerdown', (event) => {
        isDragging = true;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        scroller.scrollLeft = startScrollLeft - (event.clientX - startX);
      });

      const stopDragging = () => {
        isDragging = false;
        scroller.classList.remove('is-dragging');
      };

      scroller.addEventListener('pointerup', stopDragging);
      scroller.addEventListener('pointercancel', stopDragging);
      scroller.addEventListener('pointerleave', stopDragging);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
